module.exports = __webpack_public_path__ + "img/meauicon3.2a472459.svg";